export default class TextToImageConverter {
  constructor() {
    this.canvas = document.createElement('canvas');
  }

  getImageData(text, fontFamily, fontSize, fontWeight) {
    if (!text || text.length === 0) {
      return [];
    }
    const font = `${fontWeight} ${fontSize}px ${fontFamily}`;
    const ctx = this.canvas.getContext('2d');

    ctx.font = font;
    ctx.canvas.width = ctx.measureText(text).width;
    ctx.canvas.height = fontSize * 1.4;

    this.width = ctx.canvas.width;
    this.height = ctx.canvas.height;

    ctx.font = font;
    ctx.fillText(text, 0, fontSize);

    const imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
    return imgData.data;
  }
}



// WEBPACK FOOTER //
// ./src/lib/TextToImageConverter.js